import { call, put, takeEvery } from 'redux-saga/effects'
import { actions } from './actions'
import {
  getRestriccionesEntrega,
  getRestriccionEntregaById,
  insertRestriccionEntrega,
  insertRestriccionEntregaBulk,
  deleteRestriccionesEntregaBulk
} from 'services/logisticaPedido'
import { putMessage, messageType } from 'utiles/mensaje'
import { push } from 'connected-react-router'

// Cargar lista de restricciones
export function* RESTRICCIONES_ENTREGA_LOAD() {
  try {
    const response = yield call(getRestriccionesEntrega, arguments[0].payload)
    yield put({
      type: actions.RESTRICCIONES_ENTREGA_LOAD_SUCCEEDED,
      payload: response.data,
    })
  } catch (error) {
    yield put({
      type: actions.RESTRICCIONES_ENTREGA_LOAD_FILED,
      payload: error.message,
    })
    yield call(putMessage, messageType.ERROR, error.message)
  }
}

// Cargar restricción por ID
export function* RESTRICCION_ENTREGA_BYID_LOAD() {
  try {
    const restriccionId = arguments[0].payload
    const response = yield call(getRestriccionEntregaById, restriccionId)
    yield put({
      type: actions.RESTRICCION_ENTREGA_BYID_LOAD_SUCCEEDED,
      payload: response.data,
    })
  } catch (error) {
    yield put({
      type: actions.RESTRICCION_ENTREGA_BYID_LOAD_FILED,
      payload: error.message,
    })
    yield call(putMessage, messageType.ERROR, error.message)
  }
}

// Insertar restricción
export function* RESTRICCION_ENTREGA_INSERT() {
  try {
    const restriccion = arguments[0].payload
    const response = yield call(insertRestriccionEntrega, restriccion)
    yield put({
      type: actions.RESTRICCION_ENTREGA_INSERT_SUCCEEDED,
      payload: response.data,
    })
    yield call(putMessage, messageType.SUCCESS, 'Restricción de entrega creada correctamente')
    yield put(push('/restriccionentrega/list'))
  } catch (error) {
    yield put({
      type: actions.RESTRICCION_ENTREGA_INSERT_FILED,
      payload: error.message,
    })
    yield call(putMessage, messageType.ERROR, error.message)
  }
}

// Insertar restricciones en lote
export function* RESTRICCION_ENTREGA_INSERT_BULK() {
  try {
    const restriccionesBulk = arguments[0].payload
    yield call(insertRestriccionEntregaBulk, restriccionesBulk)
    yield put({
      type: actions.RESTRICCION_ENTREGA_INSERT_BULK_SUCCEEDED,
    })
    yield call(putMessage, messageType.SUCCESS, 'Restricciones de entrega creadas correctamente')
    // Recargar la lista después de la inserción en lote
    yield put({
      type: actions.RESTRICCIONES_ENTREGA_LOAD_REQUESTED,
      payload: {},
    })
  } catch (error) {
    yield put({
      type: actions.RESTRICCION_ENTREGA_INSERT_BULK_FILED,
      payload: error.message,
    })
    yield call(putMessage, messageType.ERROR, error.message)
  }
}

// Eliminar restricciones en lote
export function* RESTRICCION_ENTREGA_DELETE_BULK() {
  try {
    const ids = arguments[0].payload
    yield call(deleteRestriccionesEntregaBulk, ids)
    yield put({
      type: actions.RESTRICCION_ENTREGA_DELETE_BULK_SUCCEEDED,
    })
    yield call(putMessage, messageType.SUCCESS, 'Restricciones de entrega eliminadas correctamente')
    // Recargar la lista después de la eliminación
    yield put({
      type: actions.RESTRICCIONES_ENTREGA_LOAD_REQUESTED,
      payload: {},
    })
  } catch (error) {
    yield put({
      type: actions.RESTRICCION_ENTREGA_DELETE_BULK_FILED,
      payload: error.message,
    })
    yield call(putMessage, messageType.ERROR, 'No se pudieron eliminar las restricciones de entrega')
  }
}

export default function* restriccionEntregaSaga() {
  yield takeEvery(actions.RESTRICCIONES_ENTREGA_LOAD_REQUESTED, RESTRICCIONES_ENTREGA_LOAD)
  yield takeEvery(actions.RESTRICCION_ENTREGA_BYID_LOAD_REQUESTED, RESTRICCION_ENTREGA_BYID_LOAD)
  yield takeEvery(actions.RESTRICCION_ENTREGA_INSERT_REQUESTED, RESTRICCION_ENTREGA_INSERT)
  yield takeEvery(actions.RESTRICCION_ENTREGA_INSERT_BULK_REQUESTED, RESTRICCION_ENTREGA_INSERT_BULK)
  yield takeEvery(actions.RESTRICCION_ENTREGA_DELETE_BULK_REQUESTED, RESTRICCION_ENTREGA_DELETE_BULK)
}
